import { Layout } from "./Layout";
import { CollapsibleTab } from "./CollapsibleTab";
import { LinkTab } from "./LinkTab";

export const SideNavigator = { Layout, CollapsibleTab, LinkTab };
